module.exports = {"amp":"&","apos":"'","gt":">","lt":"<","quot":"\""}


//////////////////
// WEBPACK FOOTER
// ./node_modules/htmlparser2/node_modules/entities/maps/xml.json
// module id = vVS+
// module chunks = 1